module.exports = __webpack_public_path__ + "media/images/team__ironheadsgc-1d2b19ee47bb1eba3b07efe1cedd5279.png";